import { SupportedLanguages } from '../../i18n/constants';

import type { Country } from './types';

export const FALLBACK_COUNTRY_CODE = 'US';

export const FALLBACK_COUNTRY: Country = {
  code: '',
  name: 'Unknown Country',
  subdivisionName: 'Region',
  postalCodeName: 'Postal Code',
  isActive: false,
  cookieConsentEnabled: false,
  usercentricsSettingsId: '',
  defaultLanguage: SupportedLanguages.EN,
};

export enum GEO_RESTRICTION_DIALOG_TYPE {
  NO_SC_PURCHASE = 'NO_SC_PURCHASE',
  SOCIAL = 'SOCIAL',
  TICKET = 'TICKET',
}

export const SUPPORTED_GEO_RESTRICTION_TYPES = new Set<string>(Object.values(GEO_RESTRICTION_DIALOG_TYPE));
